<script lang="ts">
  import { Avatar } from '$ui/primitives/Avatar';

  let {
    name,
    avatarUrl,
    syncLabel,
    syncVariant = 'idle',
    onclick,
    collapsed = false
  }: {
    name: string;
    avatarUrl?: string | null;
    syncLabel: string;
    syncVariant?: 'idle' | 'syncing' | 'pending' | 'error';
    onclick?: () => void;
    collapsed?: boolean;
  } = $props();
</script>

<button type="button" class="user" class:collapsed onclick={onclick}>
  <Avatar src={avatarUrl} name={name} size="md" />
  {#if !collapsed}
    <span class="texts">
      <span class="name">{name}</span>
      <span class="sync" data-variant={syncVariant}>
        <span class="dot" aria-hidden="true"></span>
        {syncLabel}
      </span>
    </span>
  {/if}
</button>

<style>
  /* Réplica del .sidebar-footer del IAGIT. */
  .user {
    display: flex;
    align-items: center;
    gap: var(--space-3);
    width: 100%;
    padding: var(--space-4) var(--space-5);
    background: transparent;
    border: none;
    font-family: var(--font-body, var(--font-sans));
    text-align: left;
    cursor: pointer;
    transition: background 100ms var(--ease-out);
  }

  .user:hover {
    background: var(--color-surface-hover);
  }

  .user.collapsed {
    justify-content: center;
    padding: var(--space-4) 0;
  }

  .user:focus-visible {
    outline: var(--focus-ring-width) solid var(--color-focus-ring);
    outline-offset: var(--focus-ring-offset);
  }

  .texts {
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
    min-width: 0;
    flex: 1;
  }

  .name {
    font-size: 0.85rem;
    font-weight: 500;
    color: var(--color-text-primary);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sync {
    display: inline-flex;
    align-items: center;
    gap: var(--space-1);
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: var(--color-text-muted);
  }

  .dot {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--color-text-faint);
    flex: 0 0 auto;
  }

  .sync[data-variant='syncing'] .dot { background: var(--color-accent); }
  .sync[data-variant='pending'] .dot { background: var(--color-warning); }
  .sync[data-variant='error'] .dot { background: var(--color-danger); }
  .sync[data-variant='idle'] .dot { background: var(--color-success); }
</style>